import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { getPlatform } from "@/utils/nativeBridge";
import { installDeepLinkBridge } from "@/utils/deepLink";

// Install window.tossitNavigate synchronously, before React renders, so a native
// deep-link/push call is never dropped by a slow-hydrating SPA (no-op in a browser).
installDeepLinkBridge();

// App version (from package.json, injected at build time) — bump on each deployment.
const APP_VERSION = process.env.REACT_APP_VERSION || "dev";

// Stamp every request (shared apiClient AND any raw axios call) with the client
// version + platform, so the backend can gate stale/cached clients.
axios.defaults.headers.common["X-App-Version"] = APP_VERSION;
axios.defaults.headers.common["X-App-Platform"] = getPlatform();

console.log(
  `%cTossit v${APP_VERSION}`,
  "color:#006f3c;font-weight:bold;font-size:12px"
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
